{
  "es": {
    "chart": {
      "labels": {
        "view": {
          "one": "%{label}:<br><b>%{count}</b> Vista",
          "other": "%{label}:<br><b>%{count}</b> Vistas"
        },
        "pledgePrice": "%{label}:<br><b>%{count}</b> USD",
        "ingamePrice": "%{label}:<br><b>%{count} %</b>",
        "wishToOwnRatio": "%{label}:<br><b>%{count}</b> deseadas por 100 en posesión",
        "patchChange": {
          "one": "%{label}:<br><b>%{count}</b> cambio",
          "other": "%{label}:<br><b>%{count}</b> cambios"
        },
        "ship": {
          "one": "%{label}:<br><b>%{count}</b> Nave",
          "other": "%{label}:<br><b>%{count}</b> Naves"
        },
        "ship-pie": {
          "one": "%{label}:<br><b>%{count}</b> Nave (%{percentage} %)",
          "other": "%{label}:<br><b>%{count}</b> Naves (%{percentage} %)"
        },
        "component-pie": {
          "one": "%{label}:<br><b>%{count}</b> Componente (%{percentage} %)",
          "other": "%{label}:<br><b>%{count}</b> Componentes (%{percentage} %)"
        },
        "user": {
          "one": "%{label}:<br><b>%{count}</b> Usuario",
          "other": "%{label}:<br><b>%{count}</b> Usuarios"
        },
        "user-pie": {
          "one": "%{label}:<br><b>%{count}</b> User (%{percentage} %)",
          "other": "%{label}:<br><b>%{count}</b> Users (%{percentage} %)"
        },
        "visit": {
          "one": "%{label}:<br><b>%{count}</b> Visita",
          "other": "%{label}:<br><b>%{count}</b> Visitas"
        },
        "supporterContribution": {
          "amount": "Aportaciones: <b>%{amount}</b>",
          "goal": "Objetivo: <b>%{amount}</b>",
          "count": {
            "one": "<b>%{count}</b> patrocinador",
            "other": "<b>%{count}</b> patrocinadores"
          }
        }
      },
      "states": {
        "empty": "Todavía no hay datos para el gráfico",
        "failed": "No se pudo cargar este gráfico",
        "retry": "Inténtalo de nuevo"
      }
    }
  }
}
